import { date } from '@/lib/date';
import z from 'zod';

const startDateSchema = z.preprocess(
  (val) => {
    if (typeof val === 'string' && val.trim() !== '') {
      return date(val).startOf('day').toDate();
    }
    return val || undefined;
  },
  z.date({ message: 'Campo obrigatório.' }),
);

const endDateSchema = z.preprocess(
  (val) => {
    if (typeof val === 'string' && val.trim() !== '') {
      return date(val).endOf('day').toDate();
    }
    return val || undefined;
  },
  z.date({ message: 'Campo obrigatório.' }),
);

const endAfterStart = (
  data: { startDate?: Date; endDate?: Date },
  ctx: z.RefinementCtx,
) => {
  if (data.startDate && data.endDate && data.endDate < data.startDate) {
    ctx.addIssue({
      code: 'custom',
      message: 'Deve ser igual ou posterior ao início.',
      path: ['endDate'],
    });
  }
};

export const createEventSchema = z
  .object({
    description: z.string('Campo obrigatório.').trim().min(1, 'Campo obrigatório.'),
    startDate: startDateSchema,
    endDate: endDateSchema,
    isActive: z.boolean().optional(),
  })
  .superRefine(endAfterStart);

export const updateEventSchema = z
  .object({
    description: z
      .string('Campo obrigatório.')
      .trim()
      .min(1, 'Campo obrigatório.')
      .optional(),
    startDate: startDateSchema.optional(),
    endDate: endDateSchema.optional(),
    isActive: z.boolean().optional(),
  })
  .superRefine(endAfterStart);

export type CreateEventSchema = z.input<typeof createEventSchema>;
export type UpdateEventSchema = z.input<typeof updateEventSchema>;
